export default __webpack_public_path__ + "images/08d69c7e7f776c2c01c69e0d75c6f20b.svg";